export default {
  ROLES: ['user', 'manager', 'admin'] as const,
  MEMBERSHIP: ['LITE', 'BASIC', 'PREMIUM'] as const,
  TOKEN: {
    STALE_TIME: 600, // one hour in minute
    EXPIRATION_TIME: 3600, // one hour in second
  },
};
